import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import { mapData, handleRedirectInternal } from '@/product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import SettingContext from '@/product/context/setting/settingContext'
import CustomTable from '@/product/components/molecules/CustomTable'
import Loaders from '@/product/components/molecules/Loaders'

const InventoryLogs = (props) => {
    const settingContext = useContext(SettingContext)

    const {
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
    } = settingContext

    const [product, setProduct] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const data = props.data
    const toggleFullScreenPopup = props.function
    const [tableBody, setTableBody] = useState([])

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            primaryTable: 'inventory_logs',
            filters: {
                project_id: {
                    value: '',
                    type: 'notin',
                    field: 'il.project_id',
                },
            },
        },
        onSubmit: (values) => {
            searchTableFetch(values, 'logs')
        },
    })

    // useEffect(() => {
    //     resetFrom()
    // }, [props])

    useEffect(() => {
        if (data.status === 'logs') {
            searchTableFetch(
                {
                    page: 1,
                    limit: 20,
                    order: '',
                    orderby: '',
                    primaryTable: 'inventory_logs',
                    filters: {
                        project_id: {
                            value: data.id,
                            type: 'in',
                            field: 'il.project_id',
                        },
                    },
                },
                'logs'
            )
        }
        setIsLoading(true)
    }, [data.id])

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'logs') {
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
                setIsLoading(false)
            }
        }
    }, [search_fetch_data])
    const tableValues = []

    tableValues.push(
        {
            field: 'location',
            type: '',
            firstChild: false,
            disablePadding: false,
            label: 'Inventory Location',
        },
        {
            field: 'notes',
            type: '',
            firstChild: false,
            disablePadding: false,
            label: 'Notes',
        },
        {
            field: 'created_at',
            type: 'datetime',
            firstChild: false,
            disablePadding: false,
            label: 'Created At',
        }
    )

    return (
        <>
            <FullScreenPopup
                modaltitle={'Inventory Logs'}
                open={data.popup}
                handleClose={() => toggleFullScreenPopup(false)}
            >
                <div className="addUserModal">
                    <div className="dashboard listing">
                        <div className="miscActions d-flex justify-content-start align-items-center flex-wrap mt-4 mb-4"></div>
                        {isLoading ? (
                            <Loaders name="table" isLoading={isLoading} />
                        ) : (
                            <CustomTable
                                formik={formik.values}
                                tableBody={tableBody}
                                tableValues={tableValues}
                                tableActions={[]}
                                allData={{ totalRecords: tableBody.length }}
                                changeTableFunction={searchTableFetch}
                            />
                        )}
                    </div>
                </div>
            </FullScreenPopup>
        </>
    )
}

export default InventoryLogs
